import { IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { IconName } from "@fortawesome/pro-solid-svg-icons";
import classNames from "classnames";
import React, { FC } from "react";

import { Tooltip } from "~/ui/components";
import { Icon, LoadingIcon } from "~/ui/components/icons";

export const ConversationAction: FC<{
  onClick: (e: React.MouseEvent<HTMLSpanElement>) => void;
  isLoading: boolean;
  icon: [IconPrefix, IconName];
  name: React.ReactNode;
  className?: string;
  bg?: string;
  isDelete?: boolean;
}> = ({
  onClick,
  isLoading,
  icon,
  name,
  bg = "bg-success",
  className,
  isDelete = false,
}) => (
  <Tooltip
    label={name}
    className={classNames(
      "pointer h-30px w-30px flex items-center justify-center border-light borderR-1 text-dark mg-r-md",
      bg
    )}
    onClick={onClick}
    contentClassname={classNames("pointer text-white", className)}
  >
    {isLoading ? (
      <LoadingIcon size="sm" />
    ) : (
      <Icon icon={icon} color={isDelete ? "white" : "primary"} size="sm" />
    )}
  </Tooltip>
);
